import { axiosApi as axios } from '../helpers/axiosApi';
import { getCookie } from './helpers';
const CONDITION_API = "/studies/conditions/";

export const getAllConditions = (params) => {
  return axios.get(CONDITION_API, {params: params}).then(res => {
    return res.data;
  });
}

export const addCondition = (condition) => {
  return axios.post(CONDITION_API, condition, {
    headers: {
      "Authorization": `Bearer ${getCookie('access')}`
    }
  }).then(res => {
    return res.data;
  })
}

export const updateCondition = (id, body) => {
  return axios.put(`${CONDITION_API}${id}/`, body, {
    headers: {
      "Authorization": `Bearer ${getCookie('access')}`
    }
  }).then(res => {
    return res;
  })
}

export const deleteCondition = (id) => {
  return axios.delete(`${CONDITION_API}${id}/`, {
    headers: {
      "Authorization": `Bearer ${getCookie('access')}`
    }
  }).then(res => {
    return res;
  })
}

export const getSimpleConditions = () => {
  return axios.get("/studies/conditions-simple/")
  .then(res => res.data.data);
}